<template>
	<div class="rounded bg-new-label-gradient px-2 py-0.5 text-p-xs text-white">NEW</div>
</template>


